module.exports = __webpack_public_path__ + "static/media/card-logo-visa.9c4a7acd.svg";